module.exports = __webpack_public_path__ + "img/hero-background.c70f00e5.png";